import React, { useState } from "react";

import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BiEditAlt } from "react-icons/bi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FiTrash2 } from "react-icons/fi";

import { StyledMenu } from "../../../../../../../../../../components/Generic/AnchorMenu";
import { AddressTypeKeys } from "../../../../../../../../../../util/enums";
import { useDespatchContext } from "../../../../../../context/DespatchContext";
import { MenuItemContainer, MenuText } from "./styles";

interface Props {
  index: number;
  type: AddressTypeKeys;
  handleOpenEdit: () => void;
}

export const AddressItemOptionsButton = (props: Props) => {
  const { index, type, handleOpenEdit } = props;
  const { t: translate } = useTranslation();
  const { handleDeleteAddress, startEditingAddress } = useDespatchContext();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = !!anchorEl;
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        data-cy={`${index}-${type}-options`}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <BsThreeDotsVertical size={14} />
      </IconButton>
      <StyledMenu
        id={`${index}-${type}`}
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            marginTop: "7px",
          },
        }}
      >
        <MenuItemContainer
          data-cy={`${index}-${type}-edit`}
          onClick={() => {
            handleClose();
            handleOpenEdit();
            startEditingAddress(type, index);
          }}
        >
          <BiEditAlt size={22} color="#475467" />
          <MenuText color="#475467">{translate("edit")}</MenuText>
        </MenuItemContainer>

        <MenuItemContainer
          data-cy={`${index}-${type}-delete`}
          onClick={() => {
            handleDeleteAddress(type, index);
            handleClose();
          }}
        >
          <FiTrash2 size={22} color="#F04438" />
          <MenuText color="#F04438">{translate("delete")}</MenuText>
        </MenuItemContainer>
      </StyledMenu>
    </div>
  );
};
